<template>
  <VueDatePicker
    v-bind="$attrs"
    v-on="$listeners"
    :lang="lang"
  />
</template>

<script>
import VueDatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'

export default {
  name: 'DatePicker1',

  components: { VueDatePicker },

  data () {
    return {
      lang: 'ja'
    }
  }
}
</script>

<style>
.mx-calendar-content .cell.active {
  background-color: #2b6699;
}

.mx-btn:hover {
  border-color: #2b6699;
  color: #2b6699;
}

.mx-table-date .today {
  color: #2b6699;
  font-weight: bold;
}

.mx-input {
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: none;
}
.mx-input:hover,
.mx-input:focus {
  border-color: rgba(0, 0, 0, 0.15);
}
</style>
